import React from "react";
import { EyeOff } from "lucide-react";
import { Button } from "../ui/button";

export interface ConsensusBannerProps {
  hiddenCount: number;
  onShowAll: () => void;
}

const ConsensusBanner: React.FC<ConsensusBannerProps> = ({
  hiddenCount,
  onShowAll,
}) => {
  if (hiddenCount <= 0) return null;
  return (
    <div
      data-testid="consensus-banner"
      data-hidden-count={hiddenCount}
      className="flex items-center justify-between gap-3 px-3 py-2 rounded-md border border-border/60 bg-muted/30 text-sm text-muted-foreground"
    >
      <div className="flex items-center gap-2">
        <EyeOff className="w-4 h-4" aria-hidden />
        <span>
          {hiddenCount} créneau{hiddenCount > 1 ? "x" : ""} masqué
          {hiddenCount > 1 ? "s" : ""}
        </span>
      </div>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onShowAll}
        data-testid="consensus-show-all"
      >
        Tout afficher
      </Button>
    </div>
  );
};

export default ConsensusBanner;
